

import React from 'react';
import { useParams } from 'react-router-dom';
import exact from 'prop-types-exact';
import SinglePromotions from '../../components/promotions/containers/SinglePromotionsContainers ';
import { fetchSinglePromotionIfNeeded } from '../../components/promotions/actions/SinglePromotionsActions';

const PromocaoInterna = () => {
    const { slug } = useParams();

    return (
        <div className="pageWrapper tw-container tw-m-auto tw-px-5">
            <SinglePromotions slug={slug} />
        </div>
    );
};

PromocaoInterna.fetchData = (store, match) => store.dispatch(fetchSinglePromotionIfNeeded(match.params.slug));

PromocaoInterna.propTypes = exact({});

export default PromocaoInterna;
